type TSizeUnit = "B" | "KB" | "MB" | "GB" | "TB";

type TParsedSize = {
  value: number;
  unit: TSizeUnit;
};

export function parseSize(size: number): TParsedSize {
  const units: TSizeUnit[] = ["B", "KB", "MB", "GB", "TB"];
  const threshold = 1000;

  let unitIndex = 0;
  let value = size;

  while (value >= threshold && unitIndex < units.length - 1) {
    value /= threshold;
    unitIndex++;
  }

  return {
    value: parseFloat(value.toFixed(1)),
    unit: units[unitIndex]
  };
}
